/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
import React, { forwardRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { RootState } from '../../redux/rootState';
import ComponentJobOrder from '../ScreenReportPdf/components/ComponentJobOrder/ComponentJobOrder';
import ExpenseReport from '../ScreenReportPdf/components/ComponentsExpenseReport';
import ComponentReciepts from './ComponentReciepts';

const MorningComponentToPrint = forwardRef<HTMLDivElement>((props, ref) => {
  const {
    morningReportPdfData, morningReportData,
  } = useSelector((state:RootState) => state.dashboardReducer);

  const myData = useMemo(() => Object.values(morningReportPdfData), [morningReportPdfData]);
  const myJobOrders = useMemo(() => Object.keys(morningReportPdfData), [morningReportPdfData]);

  const receivedReports = useMemo(() => {
    const filteredReports = morningReportData?.RecordsForMorningReport?.filter((item) => myJobOrders.includes(item?.JobOrder));
    const received = filteredReports?.map((item, index) => ({
      id: String(index + 1),
      jobOrder: item?.JobOrder,
      siteName: item?.Site,
      analyst: item?.Initials,
      receiveDate: item?.ReceiveDate,
      customerName: item?.Customer,
      dateSent: item?.DateSent,
      dueDate: item?.DueDate,
      isCompleted: item?.IsCompleted,
    }));
    return received;
  }, [morningReportData, myJobOrders]);

  return (
    <div
      ref={ref}
      className="morning-report-pdf"
      style={{
        width: '794px',
        margin: '0 auto',
        backgroundColor: '#FFFFFF',
        boxSizing: 'border-box',
      }}
    >
      <div className="w100 p40 column_align">
        <p className="heading_text_24 underline direction_heading">Report Log - Received</p>
        <p className="heading_text_20 underline direction_heading">{dayjs().format('MM-DD-YYYY')}</p>

        <div className="row_align morning_report_header">
          <p style={{ width: '20%' }}>Job Order #</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '42%' }}>Site Name</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '12%' }}>Analyst</p>
          <p style={{ width: '2%' }}>{' '}</p>
          <p style={{ width: '20%' }}>Received Date</p>
        </div>
        {receivedReports?.map((report) => (
          <div className="row_align center_align morning_report_record">
            <p style={{ width: '20%' }}>{report?.jobOrder || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '42%', whiteSpace: 'pre-line' }}>{report?.siteName || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '12%' }}>{report?.analyst || ' '}</p>
            <p style={{ width: '2%' }}>{' '}</p>
            <p style={{ width: '20%' }}>{report?.receiveDate || ' '}</p>
          </div>
        ))}
      </div>
      <div className="page-break" />
      {myData.map((dataItem, index) => (
        <div className="print-record">
          {/* <div className="w100"> */}
          <ComponentJobOrder isMorning dataItem={dataItem?.JobOrder} comments={dataItem?.Comments} />
          {dataItem?.Expense_Report?.ExpenseReports?.length > 0 && <div className="page-break" />}
          {dataItem?.Expense_Report?.ExpenseReports?.length > 0 && <ExpenseReport isMorning dataItem={[dataItem?.Expense_Report]} />}
          {dataItem?.Expense_Receipt?.length > 0 && <div className="page-break" />}
          {dataItem?.Expense_Receipt?.length > 0 && <ComponentReciepts dataItem={dataItem?.Expense_Receipt} />}
          {index !== myData.length - 1 && <div className="page-break" />}
        </div>
      ))}
    </div>
  );
});

export default MorningComponentToPrint;
